<template>
  <div class="default-layout">
    <UpperHeader />
    <Header />
    <Nuxt />
    <ScrollToTop />
    <Footer />
    <portal-target name="modal" />
  </div>
</template>

<script>
import Header from '~/components/Header'
import Footer from '~/components/Footer'
import ScrollToTop from '~/components/ScrollToTop'
import UpperHeader from '~/components/UpperHeader'
export default {
  name: 'LayoutDefault',
  components: {
    Header,
    Footer,
    ScrollToTop,
    UpperHeader
  },
  mounted () {
    this.$nextTick(() => {
      this.$nuxt.$loading.start()
      this.handleScroll()
      this.$store.commit('SET_MODAL_REGISTER', false)
      setTimeout(() => this.$nuxt.$loading.finish(), 500)
    })
  },
  methods: {
    handleScroll () {
      if (!this.$route.hash) {
        this.$scrollToTop()
      } else {
        const hashSplit = this.$route.hash.split('#')[1]
        let ID = ''

        if (['clinic', 'klinik', 'rs', 'hospital'].includes(hashSplit)) {
          ID = 'clinic-hospital'
        } else if (['dokter', 'doctor'].includes(hashSplit)) {
          ID = 'doctor'
        } else if (['psikolog', 'psychologist'].includes(hashSplit)) {
          ID = 'psychologist'
        }

        let offsetTop = document.getElementById(ID).offsetTop
        if (document.body.clientWidth < 992 && ID === 'clinic-hospital') {
          offsetTop += 850
        } else if (document.body.clientWidth > 991 && (ID === 'clinic-hospital' || ID === 'psychologist')) {
          offsetTop += 450
        } else if (document.body.clientWidth < 992 && ID === 'psychologist') {
          offsetTop += 1250
        }

        scroll({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-thumb {
  background: #1a5cac;
}

::-webkit-scrollbar-thumb:hover {
  background: #1a5cac;
  opacity: 0.9;
}

::-webkit-scrollbar-track {
  background: #fafafa;
}
</style>
